import "bootstrap/dist/css/bootstrap.min.css";
import "./custom.css";
import "./index.css";

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";


// ✅ Toast 通知
import { Toaster } from "react-hot-toast";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <>
      <App />
      <Toaster position="top-right" containerStyle={{ zIndex: 10010 }} />
    </>
  </React.StrictMode>
);

reportWebVitals();

